'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Press = exports.PressUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _multitrack = require('helpers/multitrack');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _Media = require('decorators/Media/Media');

var _Media2 = _interopRequireDefault(_Media);

var _pressData = require('./pressData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PressUnwrapped = exports.PressUnwrapped = function (_Component) {
  (0, _inherits3.default)(PressUnwrapped, _Component);

  function PressUnwrapped() {
    (0, _classCallCheck3.default)(this, PressUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (PressUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(PressUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(PressUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('Press Module', 'Viewed press module', '', 0, { nonInteraction: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          mediaQueryMd = _props.mediaQueryMd;


      var press = (0, _pressData.pressData)();

      return _react2.default.createElement(
        'div',
        { className: 'bg--' + (backgroundColor || 'white') },
        _react2.default.createElement(
          'div',
          { className: 'pricing-press' },
          _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'press.header',
              defaultMessage: 'In the press'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'pricing-press__quotes' },
            press.quotes && press.quotes.map(function (quote) {
              return _react2.default.createElement(
                'div',
                { key: quote.source },
                _react2.default.createElement(
                  'blockquote',
                  null,
                  quote.copy
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('img', { src: quote.image, alt: quote.source })
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'pricing-press__mosaic' },
            mediaQueryMd && _react2.default.createElement('img', { src: press.mainImage.desktop, alt: 'logos' }),
            !mediaQueryMd && _react2.default.createElement('img', { src: press.mainImage.mobile, alt: 'logos' })
          )
        )
      );
    }
  }]);
  return PressUnwrapped;
}(_react.Component);

PressUnwrapped.propTypes = {
  mediaQueryMd: _propTypes2.default.bool,
  backgroundColor: _propTypes2.default.oneOf(['white', 'light'])
};

var Press = exports.Press = (0, _Media2.default)((0, _TrackDwell2.default)(PressUnwrapped));